import { RemoveFormItem } from "@/components/RemoveFormItem";
import { selectFilterHelper } from "@/helpers";
import { formFieldPropertyType, optionFieldType } from "@/propTypes";
import { Form, Input, Select } from "antd";
import { arrayOf, exact, func, string } from "prop-types";
import { useIntl } from "react-intl";

export const OptionEditStatusValueNextStatus = ({
  field,
  availableRights,
  availableStatuses,
  remove,
}) => {
  const intl = useIntl();

  return (
    <tr key={`next-status-row-${field.key}`}>
      <td>
        <Form.Item
          isListField={field.isListField}
          name={[field.name, "projectIntakeStatusId"]}
          fieldKey={[field.name, "projectIntakeStatusId"]}
          rules={[
            {
              required: true,
              message: intl.formatMessage({
                id: "newFormField.optionStatusNextStatusStatusRequired",
              }),
            },
          ]}
        >
          <Select
            style={{ maxWidth: 500, minWidth: 150 }}
            placeholder={intl.formatMessage({
              id: "newFormField.optionStatusNextStatusStatusPlaceholder",
            })}
          >
            {availableStatuses.map((status) => (
              <Select.Option value={status.id} key={status.id}>
                {status?.label?.fallback || status.id}
              </Select.Option>
            ))}
          </Select>
        </Form.Item>
      </td>
      <td>
        <Form.Item
          isListField={field.isListField}
          name={[field.name, "action", "fallback"]}
          fieldKey={[field.name, "action", "fallback"]}
          rules={[
            {
              required: true,
              message: intl.formatMessage({
                id: "newFormField.optionStatusNextStatusButtonTextRequired",
              }),
            },
          ]}
        >
          <Input
            placeholder={intl.formatMessage({
              id: "newFormField.optionStatusNextStatusButtonTextPlaceholder",
            })}
          />
        </Form.Item>
      </td>
      <td>
        <Form.Item
          isListField={field.isListField}
          name={[field.name, "availableToRoles"]}
          fieldKey={[field.name, "availableToRoles"]}
        >
          <Select
            mode="multiple"
            style={{ maxWidth: 500, minWidth: 300 }}
            allowClear
            placeholder={intl.formatMessage({
              id: "newFormField.optionStatusNextStatusPermissionsPlaceholder",
            })}
            filterOption={selectFilterHelper}
          >
            {availableRights.map(({ value, label }) => (
              <Select.Option value={value} key={value}>
                {label}
              </Select.Option>
            ))}
          </Select>
        </Form.Item>
      </td>
      <td>
        <RemoveFormItem
          parentComponent="option-edit-status-value-next-status"
          remove={() => remove(field.name)}
        />
      </td>
    </tr>
  );
};

OptionEditStatusValueNextStatus.propTypes = {
  remove: func.isRequired,
  field: optionFieldType.isRequired,
  availableRights: arrayOf(
    exact({
      value: string.isRequired,
      label: string.isRequired,
    })
  ).isRequired,
  availableStatuses: arrayOf(formFieldPropertyType),
};
